import React from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import styled from "styled-components";
import { Link } from "gatsby";
import { modifyColor } from "../../utils/helpers";

const StyledLink = styled(Link)`
  text-decoration: none;
  cursor: pointer;
`;
const StyledDiv = styled.div`
  width: 84px;
  height: 44px;
  background-color: var(--color-primary);
  color: var(--color-black);
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.3s ease-in-out;
  @media (hover: hover) {
    &:hover {
      background-color: ${({ theme }) => modifyColor(theme.colors.primary, 40)};
    }
  }
  @media (max-width: ${({ theme }) => theme.breakpoints.wideTablet}) {
    margin: 1.5rem 0 0 0;
    width: 100%;
  }
`;

const ProductButton = ({ product }) => {
  return (
    <StyledLink to={product.uri} aria-label="gå til produktet">
      <StyledDiv>
        <FontAwesomeIcon icon={faArrowRight} />
      </StyledDiv>
    </StyledLink>
  );
};

ProductButton.propTypes = {
  product: PropTypes.shape({
    uri: PropTypes.string,
  }),
};

export default ProductButton;
